// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "rules-nVAsh";
var _4 = "rules__text-3h0Jy";
export { _1 as "__esModule", _2 as "tablet", _3 as "rules", _4 as "rules__text" }
export default { "__esModule": _1, "tablet": _2, "rules": _3, "rules__text": _4 }
